import axios from '@/axios.config.js';

class AuthService {
    addFullNameToUser(user) {
        user.full_name = user.full_name =
            user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` :
                (
                    user.first_name && !user.last_name ? user.first_name :
                        (
                            !user.first_name && user.last_name ? user.first_name :
                                user.phone?.replace('+98', '0')
                        )
                )
    }

    login(user) {
        return axios
            .post('tokens', {
                phone: user.phone,
                password: user.password
            })
            .then(response => {
                this.addFullNameToUser(response.data)
                return response.data;
            });
    }

    register(user) {
        return axios
            .post('tokens/phone', {
                phone: user.phone,
            })
            .then(response => {
                return response.data;
            });
    }

    verification(data) {
        return axios
            .post('tokens/phone/verifications', {
                token: data.token,
                national_id: data.national_id,
                pin: data.pin,
            })
            .then(response => {
                return response.data;
            });
    }

    getPin(user) {
        return axios
            .post('tokens/forget-password', {
                phone: user.phone,
            })
            .then(response => {
                return response.data;
            });
    }

    verifyForgetPassword(data) {
        return axios
            .post('tokens/forget-password/verifications', {
                password: data.password,
                confirm_password: data.confirm_password,
                token: data.token,
                pin: data.pin,
            })
            .then(response => {
                this.addFullNameToUser(response.data)
                return response.data;
            });
    }

    getMe() {
        return axios
            .get('users/me')
            .then(response => {
                this.addFullNameToUser(response.data)
                return response.data;
            });
    }

    updateMe(user) {
        return axios
            .patch('users/me', {
                first_name: user.first_name,
                last_name: user.last_name,
                avatar_id: user.avatar_id,
                grade: user.grade,
                info: user.info,
            })
            .then(response => {
                this.addFullNameToUser(response.data)
                return response.data;
            });
    }

    getRoles() {
        return axios
            .get('roles')
            .then(response => {
                return response.data
            })
    }

    addTokenToRequest(config) {
        const state = JSON.parse(localStorage.getItem('authPersistent'));
        if (!state) return;
        if (config.addTokenToHeader)
            config.headers.Authorization = state.token ? `Bearer ${state.token}` : '';
    }
}

export default new AuthService();